<script setup lang="ts" name="FilterMenuOptions">
import type { Ref, StyleValue } from 'vue';

const { hasOptions } = defineProps<{
  hasOptions: boolean;
  virtualListContainer?: {
    ref: Ref<HTMLElement | null>;
    onScroll: () => void;
    style: StyleValue;
  };
}>();
</script>

<template>
  <div
    class="max-h-64 w-max min-w-full list-none overflow-y-auto overflow-x-hidden bg-white"
  >
    <div
      v-if="hasOptions"
      v-bind="virtualListContainer"
      class="min-w-[200px]"
      style="max-height: 256px"
      data-test="filter-options"
    >
      <slot />
    </div>
    <div v-else class="p-4 text-sm">No results found...</div>
  </div>
</template>
